export default __webpack_public_path__ + "static/media/we-are.9080e2a9.jpg";